import { ContainerWithoutSpacing } from './Container'
import { SpacingPropTypes } from './PropTypes'
import withFlex from './WithFlex'
import withSpacing from './WithSpacing'

interface ColumnProps {
  computedWeight?: number
  items: unknown[]
  separator?: boolean
  spacing?: SpacingPropTypes
  width?: string | number
}

// @ts-expect-error
class Column extends ContainerWithoutSpacing<ColumnProps> {}

// @ts-expect-error
Column.orientation = 'vertical'
Column.displayName = 'Column'

const ColumnWithSpacing = withSpacing(Column)
const ColumnWithFlexWithSpacing = withFlex(ColumnWithSpacing)

export default ColumnWithFlexWithSpacing
